import { getEnvVar } from '../utils/EnvironmentVariables';

// Centralized access to all Vite environment variables used by the app
// This is the single managed file for loading env configuration.

export const AWS_REGION = 'us-east-1';
export const USER_POOL_ID = getEnvVar('VITE_USER_POOL_ID');
export const CLIENT_ID = getEnvVar('VITE_CLIENT_ID');
export const APPLY_API_URL = `${getEnvVar('VITE_API_URL')}/apply`;
export const REQUIRED_GROUP = 'applicant';

// Add additional exports here as new VITE_* variables are introduced
